import type { DefaultTheme } from 'styled-components';

// Fallbacks are the OS dark theme, for a host whose theme lacks the token.
type Themed = { theme: DefaultTheme };

export const radiusFull = ({ theme }: Themed) => theme.borderRadius?.full ?? '100px';
export const radiusMedium = ({ theme }: Themed) => theme.borderRadius?.medium ?? '10px';
export const elevation3 = ({ theme }: Themed) => theme.elevation?.level3 ?? '0 4px 12px rgb(20 20 50 / 0.1)';
export const primary = ({ theme }: Themed) => theme.colors?.primary ?? '#C1C1FF';
export const surfaceHigh = ({ theme }: Themed) => theme.colors?.surfaceContainerHigh ?? '#292932';
export const surfaceHighest = ({ theme }: Themed) => theme.colors?.surfaceContainerHighest ?? '#34343D';
export const onSurface = ({ theme }: Themed) => theme.colors?.onSurface ?? '#E4E1ED';
export const onSurfaceVariant = ({ theme }: Themed) => theme.colors?.onSurfaceVariant ?? '#C7C4D7';
export const inverseSurface = ({ theme }: Themed) => theme.colors?.inverseSurface ?? '#E4E1ED';
export const inverseOnSurface = ({ theme }: Themed) => theme.colors?.inverseOnSurface ?? '#302F39';
export const surface = ({ theme }: Themed) => theme.colors?.surface ?? '#13131B';
export const surfaceContainer = ({ theme }: Themed) => theme.colors?.surfaceContainer ?? '#1F1F27';
export const outlineVariant = ({ theme }: Themed) => theme.colors?.outlineVariant ?? '#464555';
export const popoverShadow = ({ theme }: Themed) => theme.elevation?.modal ?? '0 8px 22px rgb(0 0 0 / 0.4)';
export const error = ({ theme }: Themed) => theme.colors?.error ?? '#FFB4AB';

const PRIMARY_TONES = { 50: '#6564F4', 60: '#8283FF', 80: '#C1C1FF' } as const;
export const primaryTone =
  (tone: keyof typeof PRIMARY_TONES) =>
  ({ theme }: Themed) =>
    theme.colorsSource?.primary?.[tone] ?? PRIMARY_TONES[tone];
